// extracted by mini-css-extract-plugin
module.exports = {"reservingContainer":"reserving-container__aB5v6","reserving":"reserving__bLGqs","reservingLoader":"reserving__loader__2r1Ke","ldsRing":"lds-ring__1iGgh"};